module.exports = __webpack_public_path__ + "static/media/carousel_en_AI.b57ea30d.jpg";